<template>
  <div class="top-nav-container">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="defaultActive"
        :menu-trigger="menuTrigger"
        :unique-opened="true"
        mode="horizontal"
        :class="`el-menu--${position}`"
        @select="select"
        @open="open"
        @close="close"
      >
        <top-nav-item
          v-for="menu in menuData"
          :key="menu.meta && menu.meta.id"
          :item="menu"
          :base-path="menu.path"
          :link-props="linkProps"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import '../../../../lib/styles/components/TopNav.scss'
import TopNavItem from './TopNavItem'

export default {
  name: 'TopNav',
  components: { TopNavItem },
  props: {
    position: {
      type: String,
      default: 'start'
    },
    // 当前激活菜单的index
    defaultActive: {
      type: String,
      default: ''
    },
    // 菜单列表数据
    menuData: {
      type: Array,
      default() {
        return []
      }
    },
    // 子菜单打开的触发方式
    menuTrigger: {
      type: String,
      default: 'hover'
    },
    // 外部链接跳转时携带的参数
    linkProps: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    select(index, indexPath) {
      this.$emit('select', index, indexPath)
    },
    open(index, indexPath) {
      this.$emit('open', index, indexPath)
    },
    close(index, indexPath) {
      this.$emit('close', index, indexPath)
    }
  }
}
</script>
